import * as React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';

import './App.css';

import { DtpPortalController } from './dtp-portal/dtp-portal.controller';
import { LogoAppController } from './logo-app/logo-app.controller';
import { LocHelperInstance, langChangedName } from './shared/localization/localization';
import { DtpResourcesController } from './dtp-portal/dtp-resources/dtp-resources.controller';
import { MotiveResourcesController } from './dtp-portal/dtp-resources/motive-resources.controller';

export interface IAppState {
}

export default class App extends React.Component<any, IAppState> {
    private langUpdateHandle = () => { this.forceUpdate(); }

    constructor(props: any) {
        super(props);
    }

    public componentDidMount() {
        LocHelperInstance.langChanged.addListener(langChangedName, this.langUpdateHandle);
    }

    public componentWillUnmount() {
        LocHelperInstance.langChanged.removeListener(langChangedName, this.langUpdateHandle);
    }

    public render() {
        return (
            <BrowserRouter>
                <div>
                    <Route
                        exact={true}
                        path="/"
                        render={() => <div />}
                    />
                    <Route
                        path="/logo"
                        component={LogoAppController}
                    />
                    <Route
                        path="/dtp-portal/:logoId/:hash"
                        component={DtpPortalController}
                    />                   
                    <Route
                        path="/:apiKey/dtp-resources/:visualGuid"
                        component={DtpResourcesController}
                    />
                    <Route
                        path="/:apiKey/motive-resources/:motiveId"
                        component={MotiveResourcesController}
                    />
                </div>
            </BrowserRouter>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/App.tsx